function createLink1And2AsUrlParams(link1: string, link2: string) {
  return `link1=${encodeURIComponent(link1)}&link2=${encodeURIComponent(
    link2
  )}`;
}

export default createLink1And2AsUrlParams;
